import xlsx from 'xlsx'

export function formatDate(date) {
  const d = new Date(date)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  let year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

export function lowerCaseAllCharsExceptFirstLetter(string) {
  return string.replace(/\w\S*/g, function(char) {
    return char.charAt(0) + char.slice(1).toLowerCase()
  })
}

export function calculateProgress(total, current) {
  return (100 / total) * current
}

export function checkInteger(val) {
  let newVal = val
  let integer = val.split(',')[0]

  if (integer.length > 3) {
    integer = parseInt(integer) / 1000
    newVal = integer.toFixed(3) + ',' + val.split(',')[1]
  }

  return newVal
}

export function modifyPriceForDisplay(price) {
  let val = (price || 0) / 100
  val = val.toFixed(2)
  val = val.replace('.', ',')
  val = checkInteger(val)

  return val
}

export function bytesToMb(size) {
  return size / 1048576
}

export function decodeArrBuffer(uArr) {
  let binary = ''
  const len = uArr.byteLength

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(uArr[i])
  }

  return binary
}

export function sheetsToJson(wb) {
  const result = {}
  wb.SheetNames.forEach(function(sheetName) {
    const roa = xlsx.utils.sheet_to_row_object_array(wb.Sheets[sheetName])
    if (roa.length > 0) {
      result[sheetName] = roa
    }
  })

  return result
}

export function getCatogeryTranslationString(siteCategory) {
  const key = siteCategory.toUpperCase().replace('-', '_')

  return `W2P_${key}_CATEGORY_LABEL`
}
